import {
  ADDRESS_MARKET_EXTENSION_URL,
  ADDRESS_TEMPORAL_STATUS_CURRENT,
  ADDRESS_TEMPORAL_STATUS_PREVIOUS,
  AddressTemporalStatus,
  SERVICE_ADDRESS_URL,
  VERIFY_ADDRESS_URL,
} from '../constants';

// FHIR standard Address.use values (http://hl7.org/fhir/ValueSet/address-use) used to store
// temporal status: 'old' marks a previous/historical address, 'home' marks the current one.
const ADDRESS_USE_OLD = 'old';
const ADDRESS_USE_HOME = 'home';

export function setAddressMarket(
  address: fhir.Address,
  market: fhir.Location | undefined
): fhir.Address {
  let extension = address?.extension?.filter(
    (item) => item.url !== ADDRESS_MARKET_EXTENSION_URL
  );

  if (market) {
    extension = [
      ...(extension || []),
      {
        url: ADDRESS_MARKET_EXTENSION_URL,
        valueReference: {
          display: market.name,
          reference: `${market.resourceType}/${market.id}`,
        },
      },
    ];
  }

  return {
    ...address,
    extension,
  };
}

export function getAddressMarketId(
  address: fhir.Address | undefined
): string | undefined {
  return address?.extension
    ?.find((item) => item.url === ADDRESS_MARKET_EXTENSION_URL)
    ?.valueReference?.reference?.split('/')?.[1];
}

export function getAddressMarketName(
  address: fhir.Address | undefined
): string | undefined {
  return address?.extension
    ?.find((item) => item.url === ADDRESS_MARKET_EXTENSION_URL)
    ?.valueReference?.display?.toUpperCase();
}

export function getIsServiceAddress(address: fhir.Address | undefined) {
  return address?.extension?.find((item) => item.url === SERVICE_ADDRESS_URL)
    ?.valueBoolean;
}

export function getIsVerifiedAddress(address: fhir.Address | undefined) {
  return address?.extension?.find((item) => item.url === VERIFY_ADDRESS_URL)
    ?.valueBoolean;
}

export function getAddressTemporalStatus(
  address: fhir.Address | undefined
): AddressTemporalStatus | undefined {
  if (address?.use === ADDRESS_USE_OLD) {
    return ADDRESS_TEMPORAL_STATUS_PREVIOUS;
  }
  if (address?.use === ADDRESS_USE_HOME) {
    return ADDRESS_TEMPORAL_STATUS_CURRENT;
  }
  return undefined;
}

export function setAddressTemporalStatus(
  address: fhir.Address,
  status: AddressTemporalStatus | undefined
): fhir.Address {
  let use: string | undefined;
  if (status === ADDRESS_TEMPORAL_STATUS_PREVIOUS) {
    use = ADDRESS_USE_OLD;
  } else if (status === ADDRESS_TEMPORAL_STATUS_CURRENT) {
    use = ADDRESS_USE_HOME;
  }

  const result: fhir.Address = {
    ...address,
    use,
  };

  if (status === ADDRESS_TEMPORAL_STATUS_CURRENT && address?.period) {
    result.period = { ...address.period, end: undefined };
  }

  return result;
}
